<template>
	<article v-show="isOpenModal" :ref="modalName" class="app-modal-overlay">
		<header class="app-modal-header u-container">
			<div class="app-modal-header__content">
				<div class="app-modal-close-box">
					<button
						v-if="settings.isUseAlwaysClose"
						@click="clickAlwaysClose"
						class="app-modal-close-box__btn-always-close"
						type="button"
					>
						다시 보지 않기
					</button>
					<a
						@click="closeModal"
						class="app-modal-close-box__btn-close"
						href="javascript:;"
					>
						<i class="ri-close-line"></i>
					</a>
				</div>
				<h2 class="app-modal-title">{{ settings.title }}</h2>
			</div>
		</header>
		<div class="app-modal-body u-container">
			<div class="app-modal-body__content">
				<div class="app-modal-content">
					<slot></slot>
				</div>
			</div>
		</div>
	</article>
</template>

<script>
export default {
	props: {
		settings: {
			type: Object,
			default: () => {
				return {
					name: '',
					title: '',
					isUseAlwaysClose: false,
					isOpen: false,
				};
			},
			validator(value) {
				return value.name && value.title;
			},
		},
	},
	computed: {
		isOpenModal() {
			return this.$store.getters['appStore/isOpenModal'];
		},
		modalName() {
			const name = this.settings.name;
			return `appModal${name.charAt(0).toUpperCase()}${name.slice(1)}`;
		},
		isModalCloseState() {
			return (
				this.settings.isUseAlwaysClose && !!localStorage.getItem(this.modalName)
			);
		},
	},
	created() {
		// 이전에 다시 보지 않기 버튼을 클릭하여 스토리지에 내용이 있을 경우 모달을 닫는다.
		if (this.isModalCloseState) {
			this.closeModal();
		}
		if (!this.isModalCloseState && this.settings.isOpen) {
			this.openModal();
		}
	},
	methods: {
		openModal() {
			this.$store.commit('appStore/openModal');
		},
		closeModal() {
			this.$store.commit('appStore/closeModal');
		},
		clickAlwaysClose() {
			if (localStorage.getItem(this.modalName) === null) {
				localStorage.setItem(this.modalName, 'alwaysClose');
				this.closeModal();
			}
		},
	},
};
</script>
